import { environments } from "@/lib/config";
import { DialogType } from "@/types/common";
import { redirect } from "next/navigation";
import ConfirmDialog from "../confirm-dialog";
import { useTypedTranslations } from "@/i18n/typed";

const authServerUrl = environments.authServerUrl;

function RequiredLoginDialog({ isOpen, onClose }: DialogType) {
  const t = useTypedTranslations("dialogs");
  return (
    <ConfirmDialog
      open={isOpen}
      title={t("loginRequired.title")}
      content={t("loginRequired.description")}
      okText={t("loginRequired.okText")}
      onOk={() => redirect(authServerUrl ?? "/")}
      cancelText={t("loginRequired.cancelText")}
      onCancel={onClose}
    ></ConfirmDialog>
  );
}

export default RequiredLoginDialog;
